module.exports = __webpack_public_path__ + "img/Union.65233c0e.svg";